import { runEvalScript } from "../../jsxProviders";
import { getRoot } from "mobx-state-tree";
import { RootInstance, rootStore } from "../root";
import { getSimpleSeparator } from "../../helpers/osHelper";

type PathAndName = {
  path: string;
  assetName: string;
};

type AssetsData = {
  images?: PathAndName[];
  videos?: PathAndName[];
  audio?: PathAndName[];
  fonts?: IFontsFromComp[];
};

export async function getAssets(self: any): Promise<AssetsData> {
  const imagesNamesFromComp: string[] = [];
  const videosNamesFromComp: string[] = [];
  const audioNamesFromComp: string[] = [];
  const assetsData: AssetsData = {};
  self.compJson.assets
    .filter((a: any) => a.p)
    .map((a: any) => a.p)
    .forEach((name: string) => {
      const fileExt = name.split(".").pop()?.toLowerCase();
      if (fileExt && /(gif|jpe?g|tiff?|png|webp|bmp)$/.test(fileExt)) {
        imagesNamesFromComp.push(name);
      } else if (fileExt && /(mov|avi|wmv|flv|3gp|mp4|mpg)$/.test(fileExt)) {
        videosNamesFromComp.push(name);
      } else if (fileExt && /(mp3|m4a|flac|wav|wma|aac)$/.test(fileExt)) {
        audioNamesFromComp.push(name);
      }
    });
  const filesFolderPath =
    rootStore.renderStore.filesFolderPath + getSimpleSeparator() + "images";

  const filteredImages =
    imagesNamesFromComp.length > 0
      ? imagesNamesFromComp.map((imageName) => ({
          path: filesFolderPath + getSimpleSeparator() + imageName,
          assetName: imageName,
        }))
      : undefined;

  if (filteredImages) assetsData.images = filteredImages;

  const filterdVideos =
    videosNamesFromComp.length > 0
      ? videosNamesFromComp.map((videoName) => ({
          path: filesFolderPath + getSimpleSeparator() + videoName,
          assetName: videoName,
        }))
      : undefined;
  if (filterdVideos) assetsData.videos = filterdVideos;

  const filterdAudio =
    audioNamesFromComp.length > 0
      ? audioNamesFromComp.map((audioName) => ({
          path: filesFolderPath + getSimpleSeparator() + audioName,
          assetName: audioName,
        }))
      : undefined;
  if (filterdAudio) assetsData.audio = filterdAudio;

  const fontsFromJSON: IFontsFromJSON[] = self.compJson.fonts?.list;
  const compId =
    getRoot<RootInstance>(self).compositionStore.compositionCurrentlyRendering.id;
  const fontsFromComp = (await runEvalScript(
    "$._blingsio.dataManager.getFonts(" + compId + ")"
  )) as IFontsFromComp[];

  if (fontsFromComp.length > 0) {
    assetsData.fonts = fontsFromJSON
      ? (fontsFromJSON
          .map((ffj: any) => {
            return fontsFromComp.find(
              (font) =>
                font.family === ffj.fFamily &&
                font.styleAndWeight === ffj.fStyleAndWeight &&
                font.name === ffj.fName
            );
          })
          .filter((v) => v) as IFontsFromComp[])
      : undefined;
  }
  if (assetsData.fonts) {
    assetsData.fonts.forEach((font) => {
      font.family = "_" + font.family.split(" ").join("_");
    });
    self.compJson.fonts?.list?.forEach((font: any) => {
      font.fFamily = "_" + font.fFamily.split(" ").join("_");
    });
  }
  return assetsData;
}
